import axios from "axios"

interface FetchEventsOptimizedOptions {
    limit?: number
    skip?: number
    approved?: boolean
    upcoming?: boolean
    organisation?: string
    venue?: string
    fields?: string[]
    include?: string[]
}

/**
 * Fetch optimized events list from v2 API
 * By default returns only approved and upcoming events
 * Returns minimal fields needed for event cards: _id, titles, labels, slug, media, event_date, upcoming_date, upcoming_time, availableTickets
 */
export default async function fetchEventsOptimized(
    options: FetchEventsOptimizedOptions = {}
) {
    const {
        limit,
        skip,
        approved,
        upcoming,
        organisation,
        venue,
        fields,
        include,
    } = options

    const params = new URLSearchParams()

    if (limit) params.append("limit", limit.toString())
    if (skip) params.append("skip", skip.toString())
    // Only add approved/upcoming if explicitly set (defaults to true on backend)
    if (approved !== undefined) params.append("approved", approved.toString())
    if (upcoming !== undefined) params.append("upcoming", upcoming.toString())
    if (organisation) params.append("organisation", organisation)
    if (venue) params.append("venue", venue)
    
    // If no fields specified, use minimal fields for event cards
    if (fields && fields.length > 0) {
        params.append("fields", fields.join(","))
    } else {
        // Default fields for event cards
        const defaultFields = [
            "_id",
            "en_title",
            "ar_title",
            "en_label",
            "ar_label",
            "slug",
            "posters",
            "media",
            "event_date",
            "upcoming_date",
            "upcoming_time",
            "lowest_price"
        ]
        params.append("fields", defaultFields.join(","))
    }
    
    if (include && include.length > 0) {
        params.append("include", include.join(","))
    }

    const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL_V2}events?${params.toString()}`
    )

    if (data) {
        return data
    } else {
        throw new Error("Failed to fetch events")
    }
}
